import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    List,
    ListItem,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { NativeVideoPlayer } from "../misc/VideoPlayer";
import AppCheckbox from "../form/AppCheckbox";
import { useMutation } from "@apollo/client";
import { WARNING_REVIEW_SUBMIT } from "@/graphql/mutations/warning";
import { useRouter } from "next/router";
import CloseIcon from "@mui/icons-material/Close";
import AppSearchField from "../app/AppSearchField";
import WarningReviewReasonList from "./WarningReviewReasonList";
import { errorToast } from "@/utils/toasts";
import AppTextField from "../form/AppTextField";

const REVEW_VIDEW_STEP = 1;
const REVIEW_ALLOWED_CONFIRM_STEP = 2;
const REVIEW_NOT_ALLOWED_STEP = 3;
const REVIEW_CHOOSE_REASON_STEP = 4;
const REVIEW_OTHER_STEP = 5;

export default function WarningReviewContainer({
    onClose,
    warning,
    onOpenPaymentDialog,
    remaining,
}) {
    const router = useRouter();
    const [step, setStep] = useState(REVEW_VIDEW_STEP);

    const [search, setSearch] = useState("");
    const [reason, setReason] = useState("");
    const [customReason, setCustomReason] = useState("");

    const [stepVideoChecked, setStepVideoChecked] = useState(false);

    const [warningReviewSubmit, { loading: warningReviewSubmitLoading }] =
        useMutation(WARNING_REVIEW_SUBMIT);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="sm"
            sx={{
                ".MuiPaper-root": {
                    margin: { xs: "8px" },
                    width: { xs: "100%" },
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "10px 16px",
                }}
            >
                <Typography fontWeight={"bold"} fontSize={"1.1rem"}>
                    درخواست بازبینی جریمه
                </Typography>

                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent>
                {step === REVEW_VIDEW_STEP && (
                    <Box>
                        <Typography>
                            قبل از ثبت درخواست،‌ لازم است ویدیوی زیر را مشاهده
                            کنید
                        </Typography>

                        <Box height="16px" />

                        <NativeVideoPlayer
                            videoUrl={
                                "https://dl2.onlinehawzah.com/pordl/habit-15/question/Penalty-review.mp4"
                            }
                        />

                        <Box height="8px" />
                        <Divider />
                        <Box height="16px" />

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Typography sx={{ fontSize: "0.9rem" }}>
                                دفعات مجاز باقیمانده در این چله
                            </Typography>

                            <Typography sx={{ fontSize: "0.9rem" }}>
                                {remaining}
                            </Typography>
                        </Box>

                        <Box height="16px" />
                        <Divider />
                        <Box height="8px" />

                        <AppCheckbox
                            label={"شرایط را مشاهده کردم و می‌پذیرم"}
                            checked={stepVideoChecked}
                            onChange={(e) =>
                                setStepVideoChecked(e.target.checked)
                            }
                        />

                        <Box height="32px" />

                        <Box sx={{ display: "flex" }}>
                            <Button
                                variant="outlined"
                                sx={{ fontWeight: "bold" }}
                                onClick={onClose}
                                size="large"
                                fullWidth
                            >
                                انصراف
                            </Button>

                            <Box width="32px" />

                            <Button
                                variant="contained"
                                sx={{ fontWeight: "bold" }}
                                disabled={!stepVideoChecked}
                                onClick={() =>
                                    setStep(REVIEW_ALLOWED_CONFIRM_STEP)
                                }
                                size="large"
                                fullWidth
                            >
                                ادامه
                            </Button>
                        </Box>
                    </Box>
                )}

                {step === REVIEW_ALLOWED_CONFIRM_STEP && (
                    <Box>
                        <Typography>
                            با توجه به ویدیو، درخواست شما در لیست مجاز است یا
                            غیر مجاز؟
                        </Typography>

                        <Box height="32px" />

                        <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                            gap={2}
                        >
                            <Button
                                variant="contained"
                                sx={{ fontWeight: "bold" }}
                                onClick={() =>
                                    setStep(REVIEW_CHOOSE_REASON_STEP)
                                }
                                size="large"
                                fullWidth
                            >
                                لیست مجاز
                            </Button>

                            <Button
                                variant="outlined"
                                sx={{ fontWeight: "bold" }}
                                onClick={() => setStep(REVIEW_NOT_ALLOWED_STEP)}
                                size="large"
                                fullWidth
                            >
                                لیست غیر مجاز
                            </Button>

                            <Button
                                variant="outlined"
                                sx={{ fontWeight: "bold" }}
                                onClick={() => setStep(REVIEW_OTHER_STEP)}
                                size="large"
                                fullWidth
                            >
                                سایر
                            </Button>
                        </Box>
                    </Box>
                )}

                {step === REVIEW_NOT_ALLOWED_STEP && (
                    <Box>
                        <Typography>
                            همانطور که شرح داده شد
                            <Typography
                                variant="span"
                                sx={{ fontWeight: "bold", padding: "0 3px" }}
                            >
                                امکان بازبینی جریمه به دلایل غیرمجاز وجود ندارد
                            </Typography>
                            و لازم است برای ادامه دوره، جریمه خود را پرداخت
                            نمایید.
                        </Typography>

                        <Typography>
                            در صورت وجود هرگونه سوال یا مشکل، می‌توانید با
                            پشتیبان دوره در ارتباط باشید.
                        </Typography>

                        <Box height="32px" />

                        <Box sx={{ display: "flex" }}>
                            <Button
                                variant="outlined"
                                sx={{ fontWeight: "bold" }}
                                onClick={() => {
                                    onClose();
                                    try {
                                        window?.Goftino?.open();
                                    } catch (e) {}
                                }}
                                size="large"
                                fullWidth
                            >
                                ارتباط با پشتیبان{" "}
                            </Button>

                            <Box width="32px" />

                            <Button
                                variant="contained"
                                sx={{ fontWeight: "bold" }}
                                onClick={() => {
                                    onClose();
                                    onOpenPaymentDialog();
                                }}
                                size="large"
                                fullWidth
                            >
                                پرداخت جریمه{" "}
                            </Button>
                        </Box>
                    </Box>
                )}

                {step === REVIEW_OTHER_STEP && (
                    <Box>
                        <Typography sx={{ fontSize: "0.9rem" }}>
                            با نوشتن دلیل در «سایر»، دلیل بازبینی شما ثبت می‌شود{" "}
                            <Typography
                                variant="span"
                                sx={{
                                    fontWeight: "bold",
                                    textDecoration: "underline",
                                    fontSize: "inherit",
                                }}
                            >
                                اما جریمه برداشته نمی‌شود.
                            </Typography>
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: "bold",
                                textDecoration: "underline",
                                fontSize: "0.9rem",
                            }}
                        >
                            همچنین از دفعات مجاز بازبینی شما کم نخواهد شد.
                        </Typography>

                        <Typography>
                            تیم پشتیبانی، دلیل شما را بررسی خواهد کرد و در صورت
                            تایید به لیست اضافه می‌شود.
                        </Typography>

                        <Box height="16px" />

                        <AppTextField
                            fullWidth
                            required
                            rows={3}
                            multiline
                            label="دلیل مجاز خود را بنویسید"
                            value={customReason}
                            onChange={(e) => setCustomReason(e.target.value)}
                        />
                        {customReason?.length < 14 && (
                            <Typography
                                sx={{
                                    fontSize: "0.75rem",
                                    color: "#FE0000",
                                    padding: "4px 0",
                                }}
                            >
                                دلیل خود را کامل بنویسید تا امکان ثبت آن فراهم
                                شود
                            </Typography>
                        )}

                        <Box height="16px" />

                        <Box sx={{ display: "flex" }}>
                            <Button
                                size="large"
                                variant="outlined"
                                sx={{ fontWeight: "bold" }}
                                onClick={onClose}
                                disabled={warningReviewSubmitLoading}
                                fullWidth
                            >
                                انصراف
                            </Button>

                            <Box width="32px" />

                            <Button
                                variant="contained"
                                size="large"
                                fullWidth
                                sx={{
                                    whiteSpace: "nowrap",
                                    fontWeight: "bold",
                                }}
                                disabled={customReason?.length < 14}
                                onClick={() => {
                                    warningReviewSubmit({
                                        variables: {
                                            warningId: warning.warningId,
                                            requestType: "OTHER",
                                            reasonId: null,
                                            description: customReason,
                                        },
                                    })
                                        .then((res) => {
                                            const error =
                                                res?.errors?.[0]?.message ??
                                                null;
                                            if (error) {
                                                errorToast(error);
                                                return;
                                            }
                                            router.push("/review/failure");
                                        })
                                        .catch((err) => {
                                            errorToast(err?.message ?? "");
                                        });
                                }}
                            >
                                {warningReviewSubmitLoading ? (
                                    <CircularProgress size={"1.5rem"} />
                                ) : (
                                    "ثبت دلیل"
                                )}
                            </Button>
                        </Box>
                    </Box>
                )}

                {step === REVIEW_CHOOSE_REASON_STEP && (
                    <Box>
                        <Typography>
                            دلیل خود را جست‌وجو و انتخاب کنید
                        </Typography>

                        <Box height="16px" />

                        <AppSearchField
                            value={search}
                            onChange={(value) => setSearch(value)}
                            label="جست‌وجو در دلایل"
                            size="medium"
                        />

                        <WarningReviewReasonList
                            search={search}
                            reason={reason}
                            setReason={setReason}
                            customReason={customReason}
                            setCustomReason={setCustomReason}
                        />

                        <Box height="32px" />

                        <Box sx={{ display: "flex" }}>
                            <Button
                                size="large"
                                variant="outlined"
                                sx={{ fontWeight: "bold" }}
                                onClick={onClose}
                                disabled={warningReviewSubmitLoading}
                                fullWidth
                            >
                                انصراف
                            </Button>

                            <Box width="32px" />

                            <Button
                                variant="contained"
                                size="large"
                                fullWidth
                                sx={{
                                    whiteSpace: "nowrap",
                                    fontWeight: "bold",
                                }}
                                disabled={(function () {
                                    if (warningReviewSubmitLoading) return true;
                                    return !reason?.reasonId;
                                })()}
                                onClick={() => {
                                    warningReviewSubmit({
                                        variables: {
                                            warningId: warning.warningId,
                                            requestType: "REASON",
                                            reasonId: reason.reasonId,
                                            description: "",
                                        },
                                    })
                                        .then((res) => {
                                            const error =
                                                res?.errors?.[0]?.message ??
                                                null;
                                            if (error) {
                                                errorToast(error);
                                                return;
                                            }

                                            router.push(
                                                `/review/success?remaining=${
                                                    remaining - 1
                                                }`
                                            );
                                        })
                                        .catch((err) => {
                                            errorToast(err?.message ?? "");
                                        });
                                }}
                            >
                                {warningReviewSubmitLoading ? (
                                    <CircularProgress size={"1.5rem"} />
                                ) : (
                                    "ثبت دلیل"
                                )}
                            </Button>
                        </Box>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}
